import {QuicklookPreviewType} from "../types/geoMap";
import {ProductImageStacType} from "../types/product";
import {getProductIdentifierFrom} from "./productHelper";
import {AllQuicklookPreviewsType} from "../state/geoMap/types";
import {objectValues} from "./utilsHelper";
import {getAllProductImagesInOrdersSubmitted} from "./cartHelper";
import {CartOrderType} from "../types/cart";



export const canQuicklookPreviewBeLoaded = (formValues): boolean => {
  return true; // formValues.routine
};

export const getQuicklookPreviewsShownInMap = (latestAllQuicklookPreviews: AllQuicklookPreviewsType): QuicklookPreviewType[] => {
  return objectValues(latestAllQuicklookPreviews).filter((quicklookPreview) => quicklookPreview.isShownInMap);
};

export const findQuicklookPreviewFromProductImage = (
  allQuicklookPreviews: AllQuicklookPreviewsType,
  productImage: ProductImageStacType
): QuicklookPreviewType | undefined => (
  allQuicklookPreviews && allQuicklookPreviews[getProductIdentifierFrom(productImage)]
);

export const findProductImageFromQuicklookPreview = (
  productImages: ProductImageStacType[],
  ordersSubmitted: CartOrderType[],
  quicklookPreview: QuicklookPreviewType
) => {
  return productImages.find((productImage) => isQuicklookPreviewOfProductImage(quicklookPreview, productImage)) ||
    getAllProductImagesInOrdersSubmitted(ordersSubmitted).find((productImage) => isQuicklookPreviewOfProductImage(quicklookPreview, productImage))
};

export const isQuicklookPreviewOfProductImage = (quicklookPreview, productImage) => (
  quicklookPreview.productImageId === getProductIdentifierFrom(productImage)
);

export const toggleQuicklookPreviewFrom = (
  itemQuicklookPreview: QuicklookPreviewType,
  toggle: boolean
) => ({
  ...itemQuicklookPreview,
  isShownInMap: toggle
});

export const getQuicklookPreviewInformationFrom = (
  allQuicklookPreviews: AllQuicklookPreviewsType,
  productImage: ProductImageStacType
) => {
  const productImageQuicklookPreview = findQuicklookPreviewFromProductImage(allQuicklookPreviews, productImage);
  const isQuicklookPreviewAvailable = productImageQuicklookPreview && !!productImageQuicklookPreview.url;
  const isQuicklookPreviewShownInMap = isQuicklookPreviewAvailable && productImageQuicklookPreview && productImageQuicklookPreview.isShownInMap;

  return {
    productImageQuicklookPreview,
    isQuicklookPreviewAvailable,
    isQuicklookPreviewShownInMap
  }
};

export const getAllQuicklookPreviewsFromProductImages = (
  allQuicklookPreviews: AllQuicklookPreviewsType,
  productImages: ProductImageStacType[]
): QuicklookPreviewType[] => (
  productImages.map((productImage) => {
    return findQuicklookPreviewFromProductImage(allQuicklookPreviews, productImage)
  }).filter((q) => !!q) as QuicklookPreviewType[]
);

export const isProductImageQuicklookPreviewShownInMap = (
  quicklookPreviewsShownInMap: QuicklookPreviewType[],
  productImage: ProductImageStacType
): boolean => {
  return (quicklookPreviewsShownInMap || [])
    .findIndex((quicklookPreview) => (
      isQuicklookPreviewOfProductImage(quicklookPreview, productImage)
    )) >= 0;
};
